import { writable } from 'svelte/store';
import wrappedFetch from "./wrappedFetch.js";
export const User = writable(null); //({name:'Bruce Wayne', id:'1'})
export const UpdateUserStore = writable([]);
export const BaseUrl=window.location.host;//'https://eadmissions.adept.education';
export const ENV=location.href.includes('test.eadmissions.org.uk')? 'TEST':'LIVE';

export const Location = writable('');
export const ContactBoroughs = writable([]);
export const Children = writable([]);
export let TitleList = [
	{"label" : "Mr"},
	{"label" : "Mrs"},
	{"label" : "Miss"},
	{"label" : "Ms"},
	{"label" : "Mx"},
	{"label" : "Dr"},
	{"label" : "Prof"},
	{"label" : "Rev"},
	{"label" : "Pastor"},
	{"label" : "Father"},
	{"label" : "Sister"},
	{"label" : "Brother"},
	{"label" : "Rabbi"},
	{"label" : "Canon"},
	{"label" : "Cllr"},
	{"label" : "Hon"},
	{"label" : "Sir"},
	{"label" : "Dame"},
	{"label" : "Lord"},
	{"label" : "Lady"},
	{"label" : "Captain"},
	{"label" : "Colonel"},
	{"label" : "Major"},
	];

	export const isPushSupported =  "PushManager" in window && "serviceWorker" in navigator;


	export const askPushPermission = ()=> {	
		
		return new Promise(function(resolve, reject) {
		  const permissionResult = Notification.requestPermission(function(result) {
			resolve(result);
		  });	 
		  if (permissionResult) {
			permissionResult.then(resolve, reject);
		  }
		})
		.then(function(permissionResult) {
			
		  if (permissionResult !== 'granted') {
			console.log('We weren\'t granted permission.');
		  }
		  
		  return permissionResult;
		});
	  }
	  let urlBase64ToUint8Array = (base64String) => {
		const padding = '='.repeat((4 - base64String.length % 4) % 4);
		const base64 = (base64String + padding)
		  .replace(/\-/g, '+')
		  .replace(/_/g, '/');
	  
		const rawData = window.atob(base64);
		const outputArray = new Uint8Array(rawData.length);
	  
		for (let i = 0; i < rawData.length; ++i) {
		  outputArray[i] = rawData.charCodeAt(i);
		}
		return outputArray;
	  }

	  export const getUserSubscription=()=>{
		return navigator.serviceWorker.ready
		.then(function(registration) {
			return registration.pushManager.getSubscription();		
			});
	  }

	  export const subscribeUserToPush = ()=> {
		return navigator.serviceWorker.ready
		.then(function(registration) {			
		  const subscribeOptions = {
			userVisibleOnly: true,
			applicationServerKey: urlBase64ToUint8Array(
			  'BGZmPeSWCGuVARpt0Ophq5qdX2opeCKtMCEnpTNBECc1QukjamRDmOhoLNeXby_f9LmXKSj-Qyuju_175cCuRhQ'
			)
		  };
	  
		  return registration.pushManager.subscribe(subscribeOptions);
		})
		.then(function(pushSubscription) {
		 // console.log('Received PushSubscription: ', JSON.stringify(pushSubscription));
		  return JSON.stringify(pushSubscription);
		});
	  }

	  
  export const savePushSubscription = async () => {
    let pushSubscription = await subscribeUserToPush();
    // console.log('pushSubscription',pushSubscription);
    let form = new FormData();
    form.append("subscription", pushSubscription);

	return wrappedFetch(`/user/SavePushSubscriptions`, {
      method: "post",
      body: form
    })
      .then(response => response.json())
      .then(response => {
    return response;
      });
  };

	  export const triggerPushMsg = function(subscription, dataToSend) {
		return webpush.sendNotification(subscription, dataToSend)
		.catch((err) => {
		  if (err.statusCode === 404 || err.statusCode === 410) {
			//console.log('Subscription has expired or is no longer valid: ', err);
			return deleteSubscriptionFromDatabase(subscription._id);
		  } else {
			throw err;
		  }
		});
	  };

export function getParameterByName(name, url) {
		if (!url) url = window.location.href;
		name = name.replace(/[\[\]]/g, '\\$&');
		var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
			results = regex.exec(url);
		if (!results) return null;
		if (!results[2]) return '';
		return decodeURIComponent(results[2].replace(/\+/g, ' '));
	}